<template>
  <button class="primary chat-open-btn" @click="openChat">
    <img src="@/assets/icons/chat-message.svg" :alt="$t('chat.open-btn.image-label')" />
    <span>{{ $t('chat.open-btn.text') }}</span>
  </button>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  name: 'ChatOpenBtn',
  props: {
    user: Object,
  },
  methods: {
    async openChat() {
      await this.createGroupP2P(this.user).catch((err) => {
        let text = ''
        try {
          text =
            err.errors &&
            Object.keys(err.errors)
              .map((key) => err.errors[key][0])
              .join(', ')
        } catch (e) {
          console.warn(e)
        }

        this.$toast({ type: 'error', title: err.message, text })
      })
    },
    ...mapActions('chat', ['createGroupP2P']),
    ...mapMutations('chat', ['setActiveDialog', 'setReply']),
  },
}
</script>

<style lang="scss">
button.chat-open-btn {
  height: 44px !important;

  @include mobile {
    height: 45px !important;
  }
}
</style>
